import React, { useState, useRef, useEffect, useContext } from "react";
import { makeStyles } from "@material-ui/core/styles";
import { AuthContext } from "../../context/Auth/AuthContext";
import api from "../../services/api";

const useStyles = makeStyles((theme) => ({
  fab: {
    display: "none",
    pointerEvents: "none",
    opacity: 0,
    visibility: "hidden", display: "none !important",
    position: "fixed", bottom: 24, right: 24, zIndex: 1300,
    width: 52, height: 52, borderRadius: "50%",
    background: "linear-gradient(135deg, #0F1B35 0%, #1D4ED8 100%)",
    border: "none", cursor: "pointer",
    boxShadow: "0 4px 20px rgba(29,78,216,0.4)",
    display: "flex", alignItems: "center", justifyContent: "center",
    fontSize: "1.3rem", transition: "all 0.2s",
    "&:hover": { transform: "scale(1.08)", boxShadow: "0 6px 28px rgba(29,78,216,0.5)" },
    [theme.breakpoints.down("md")]: { display: "none" },
  },
  badge: {
    position: "absolute", top: -3, right: -3,
    width: 14, height: 14, borderRadius: "50%",
    background: "#22C55E", border: "2px solid #fff",
  },
  window: {
    position: "fixed", bottom: 88, right: 24, zIndex: 1300,
    width: 360, height: 520,
    [theme.breakpoints.down("sm")]: { bottom: 0, right: 0, left: 0, width: "100%", height: "85vh", borderRadius: "20px 20px 0 0" },
    background: theme.palette.type === "dark" ? "#0D1626" : "#ffffff",
    borderRadius: 20, overflow: "hidden",
    boxShadow: "0 20px 60px rgba(0,0,0,0.2), 0 0 0 1px rgba(0,0,0,0.06)",
    display: "flex", flexDirection: "column",
    fontFamily: "'Inter', system-ui, sans-serif",
    animation: "popIn 0.2s ease",
  },
  windowHeader: {
    flexShrink: 0, padding: "14px 16px",
    background: "linear-gradient(135deg, #0F1B35 0%, #1D4ED8 100%)",
    display: "flex", alignItems: "center", gap: 10,
  },
  avatarIcon: {
    width: 34, height: 34, borderRadius: 10, flexShrink: 0,
    background: "rgba(255,255,255,0.15)",
    display: "flex", alignItems: "center", justifyContent: "center", fontSize: "1rem",
  },
  messages: {
    flex: 1, overflowY: "auto", padding: "14px 14px 8px",
    display: "flex", flexDirection: "column", gap: 10,
  },
  msgBot: {
    alignSelf: "flex-start", maxWidth: "85%",
    background: theme.palette.type === "dark" ? "rgba(255,255,255,0.06)" : "#F1F5F9",
    borderRadius: "14px 14px 14px 4px",
    padding: "10px 13px", fontSize: "0.82rem",
    color: theme.palette.type === "dark" ? "#E2E8F0" : "#1E293B",
    lineHeight: 1.55,
  },
  msgUser: {
    alignSelf: "flex-end", maxWidth: "85%",
    background: "#1D4ED8", color: "#fff",
    borderRadius: "14px 14px 4px 14px",
    padding: "10px 13px", fontSize: "0.82rem", lineHeight: 1.55,
  },
  typing: {
    alignSelf: "flex-start",
    background: theme.palette.type === "dark" ? "rgba(255,255,255,0.06)" : "#F1F5F9",
    borderRadius: "14px 14px 14px 4px",
    padding: "10px 16px", display: "flex", alignItems: "center", gap: 4,
  },
  typingDot: {
    width: 6, height: 6, borderRadius: "50%", background: "#94A3B8",
    animation: "$bounce 1.2s infinite",
  },
  suggestions: {
    flexShrink: 0, padding: "6px 12px",
    display: "flex", gap: 6, flexWrap: "wrap",
    borderTop: `1px solid ${theme.palette.type === "dark" ? "rgba(255,255,255,0.05)" : "#F1F5F9"}`,
  },
  suggestionBtn: {
    borderRadius: 20, border: "1px solid rgba(29,78,216,0.2)",
    background: "rgba(29,78,216,0.05)", color: "#1D4ED8",
    fontSize: "0.72rem", fontWeight: 500, padding: "5px 10px",
    cursor: "pointer", transition: "all 0.12s",
    "&:hover": { background: "rgba(29,78,216,0.12)" },
  },
  inputArea: {
    flexShrink: 0, padding: "10px 12px",
    borderTop: `1px solid ${theme.palette.type === "dark" ? "rgba(255,255,255,0.06)" : "#F1F5F9"}`,
    display: "flex", alignItems: "flex-end", gap: 8,
    background: theme.palette.type === "dark" ? "#0D1626" : "#fff",
  },
  input: {
    flex: 1, border: `1px solid ${theme.palette.type === "dark" ? "rgba(255,255,255,0.1)" : "#E2E8F0"}`,
    borderRadius: 12, padding: "8px 12px", fontSize: "0.82rem",
    outline: "none", resize: "none", fontFamily: "inherit",
    background: theme.palette.type === "dark" ? "rgba(255,255,255,0.04)" : "#F8FAFC",
    color: theme.palette.type === "dark" ? "#E2E8F0" : "#1E293B",
    lineHeight: 1.4, maxHeight: 100,
    "&:focus": { borderColor: "#1D4ED8" },
  },
  sendBtn: {
    width: 36, height: 36, borderRadius: 10, flexShrink: 0,
    background: "#1D4ED8", border: "none", cursor: "pointer",
    display: "flex", alignItems: "center", justifyContent: "center",
    color: "#fff", fontSize: "0.9rem", transition: "all 0.15s",
    "&:hover": { background: "#1E40AF" },
    "&:disabled": { background: "#94A3B8", cursor: "not-allowed" },
  },
  "@keyframes bounce": {
    "0%, 60%, 100%": { transform: "translateY(0)" },
    "30%": { transform: "translateY(-5px)" },
  },
  "@keyframes popIn": {
    "0%": { opacity: 0, transform: "scale(0.95) translateY(10px)" },
    "100%": { opacity: 1, transform: "scale(1) translateY(0)" },
  },
}));

const KORAX_SYSTEM_PROMPT = `Você é o assistente de suporte da plataforma Korax — um CRM inteligente para operações comerciais via WhatsApp.

Sua função é ajudar usuários a entender e usar todas as funcionalidades da plataforma com clareza, objetividade e simpatia.

CONHECIMENTO DA PLATAFORMA KORAX:

## ATENDIMENTOS (Tickets)
- Central de conversas via WhatsApp
- Status: Abertos, Aguardando, Grupos, Fechados
- Filtros por setor (filas), atendente e status
- Modo Missão: IA que sugere próxima ação comercial em tempo real
- Etiquetas para classificar leads
- Transferência entre atendentes
- Busca de mensagens

## KORAX IA (Agentes)
- Agentes de IA que atendem automaticamente
- Construtor Inteligente: wizard para criar fluxos de vendas
- Biblioteca de Mídias: cadastro de áudios, vídeos, imagens e PDFs
- Comando [ENVIAR_MIDIA: chave] no prompt para enviar mídias automaticamente
- Suporte a GPT-4o, GPT-4o-mini e Gemini
- Configuração de temperatura, tokens e máximo de mensagens

## KANBAN
- Funil visual de vendas com colunas personalizáveis
- Arraste leads entre etapas
- Visualização do progresso por lead

## FOLLOW-UP
- Agendamento automático de mensagens
- Programação por intervalo: horas, dias
- Reengajamento de leads parados

## SETORES (Filas/Queues)
- Organização por departamento: Vendas, Suporte, Financeiro
- Cada setor pode ter sua própria IA configurada
- Atendentes vinculados por setor

## CONEXÕES (WhatsApp)
- Conexão via QR Code
- Suporte a múltiplos números
- Status de conexão em tempo real

## CONTATOS
- Base de contatos centralizada
- Histórico de todas as conversas
- Tags e informações personalizadas

## CAMPANHAS
- Disparo em massa para listas
- Segmentação por tags

## AGENDAMENTOS
- Mensagens programadas individualmente
- Integração com follow-up

## CONFIGURAÇÕES
- Usuários e permissões (Admin / Atendente)
- Planos e faturamento
- Integrações externas

## ONBOARDING
- Guia lateral de configuração sempre disponível
- Acesse pelo botão 🧭 no topo da tela

REGRAS:
- Seja direto e objetivo
- Use linguagem simples, sem jargão técnico excessivo
- Se não souber, diga que vai verificar e sugira abrir um ticket de suporte
- Nunca invente funcionalidades que não existem
- Máximo 3 parágrafos por resposta
- Use emojis com moderação para tornar mais amigável`;

const SUGGESTIONS = [
  "Como conectar o WhatsApp?",
  "Como criar um agente IA?",
  "Como usar o Kanban?",
  "Como configurar follow-up?",
  "Como criar setores?",
  "O que é o Modo Missão?",
];

const KoraxAssistant = () => {
  const classes = useStyles();
  const { user } = useContext(AuthContext);
  const [open, setOpen] = useState(false);
  useEffect(() => {
    const handler = () => setOpen(true);
    window.addEventListener("openKoraxAssistant", handler);
    return () => window.removeEventListener("openKoraxAssistant", handler);
  }, []);
  const [input, setInput] = useState("");
  const [loading, setLoading] = useState(false);
  const [apiKey, setApiKey] = useState(null);
  const [model, setModel] = useState("gpt-4o-mini");
  const [messages, setMessages] = useState([
    { role: "bot", text: "Olá! 👋 Sou o assistente Korax. Posso te ajudar com qualquer dúvida sobre a plataforma. Como posso te ajudar?" }
  ]);
  const [showSuggestions, setShowSuggestions] = useState(true);
  const messagesEndRef = useRef(null);

  useEffect(() => {
    if (open && !apiKey) {
      api.get("/prompt").then(r => {
        const p = r.data?.prompts?.[0];
        if (p?.apiKey) { setApiKey(p.apiKey); setModel(p.model || "gpt-4o-mini"); }
      }).catch(() => {});
    }
  }, [open]);

  useEffect(() => {
    messagesEndRef.current?.scrollIntoView({ behavior: "smooth" });
  }, [messages, loading]);

  const send = async (text) => {
    const msg = text || input.trim();
    if (!msg || loading) return;
    setInput("");
    setShowSuggestions(false);
    setMessages(prev => [...prev, { role: "user", text: msg }]);
    setLoading(true);

    try {
      if (!apiKey) {
        setMessages(prev => [...prev, { role: "bot", text: "⚠️ Nenhuma API Key configurada. Acesse Korax IA e cadastre um agente com sua chave OpenAI." }]);
        setLoading(false); return;
      }

      const history = messages.slice(-8).map(m => ({
        role: m.role === "user" ? "user" : "assistant",
        content: m.text,
      }));

      const { data } = await api.post("/prompt/test", {
        prompt: KORAX_SYSTEM_PROMPT,
        message: msg,
        history,
        apiKey,
        model,
        maxTokens: 500,
      });

      setMessages(prev => [...prev, { role: "bot", text: data.reply || "Não consegui processar sua pergunta. Tente novamente." }]);
    } catch {
      setMessages(prev => [...prev, { role: "bot", text: "❌ Erro ao conectar com a IA. Verifique sua API Key nas configurações." }]);
    }
    setLoading(false);
  };

  const handleKey = (e) => {
    if (e.key === "Enter" && !e.shiftKey) { e.preventDefault(); send(); }
  };

  return (
    <div style={{ position: "fixed", zIndex: 1300, bottom: 0, right: 0, pointerEvents: "none" }}>
      <div style={{ pointerEvents: "auto" }}>
      {/* JANELA DO CHAT */}
      {open && (
        <div className={classes.window}>
          {/* HEADER */}
          <div className={classes.windowHeader}>
            <div className={classes.avatarIcon}>⚡</div>
            <div style={{ flex: 1 }}>
              <div style={{ fontWeight: 700, fontSize: "0.88rem", color: "#fff" }}>Assistente Korax</div>
              <div style={{ fontSize: "0.65rem", color: "rgba(255,255,255,0.65)", marginTop: 1, display: "flex", alignItems: "center", gap: 4 }}>
                <span style={{ width: 6, height: 6, borderRadius: "50%", background: "#22C55E", display: "inline-block" }} />
                IA online • Suporte da plataforma
              </div>
            </div>
            <button onClick={() => setOpen(false)} style={{ background: "rgba(255,255,255,0.1)", border: "none", color: "rgba(255,255,255,0.7)", borderRadius: 7, width: 28, height: 28, cursor: "pointer", fontSize: "1rem", display: "flex", alignItems: "center", justifyContent: "center" }}>×</button>
          </div>

          {/* MENSAGENS */}
          <div className={classes.messages}>
            {messages.map((m, i) => (
              <div key={i} className={m.role === "user" ? classes.msgUser : classes.msgBot}
                style={{ whiteSpace: "pre-wrap" }}>
                {m.text}
              </div>
            ))}
            {loading && (
              <div className={classes.typing}>
                {[0, 0.2, 0.4].map((d, i) => (
                  <div key={i} className={classes.typingDot} style={{ animationDelay: `${d}s` }} />
                ))}
              </div>
            )}
            <div ref={messagesEndRef} />
          </div>

          {/* SUGESTÕES */}
          {showSuggestions && (
            <div className={classes.suggestions}>
              {SUGGESTIONS.map((s, i) => (
                <button key={i} className={classes.suggestionBtn} onClick={() => send(s)}>{s}</button>
              ))}
            </div>
          )}

          {/* INPUT */}
          <div className={classes.inputArea}>
            <textarea
              className={classes.input}
              value={input}
              onChange={e => setInput(e.target.value)}
              onKeyDown={handleKey}
              placeholder="Digite sua dúvida..."
              rows={1}
            />
            <button className={classes.sendBtn} onClick={() => send()} disabled={!input.trim() || loading}>
              ➤
            </button>
          </div>
        </div>
      )}

      {/* FAB */}
      {typeof window !== "undefined" && window.innerWidth > 960 && (
        <button style={{ display: "none" }} className={classes.fab} onClick={() => setOpen(!open)}>
          {open ? "×" : "⚡"}
          {!open && <div className={classes.badge} />}
        </button>
      )}
      </div>
    </div>
  );
};

export default KoraxAssistant;
